
const EnvService = {

    apiBaseURL: process.env.VUE_APP_API_URL,
  
    appEnv: process.env.NODE_ENV,
  
    isDev() {
      return this.appEnv === 'development'
    },
  
    getUrl(path) {
      return location.origin + (path.charAt(0) !== '/' ? '/' : '') + path
    },
  
  }
  
  export default EnvService
  